import { render, staticRenderFns } from "./BGrupoDadosFilterBar.vue?vue&type=template&id=1566f18f"
import script from "./BGrupoDadosFilterBar.vue?vue&type=script&lang=js"
export * from "./BGrupoDadosFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports